import { Avatar, Button, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import { Chip, Typography } from "@mui/material/node";
import Stack from '@mui/material/Stack';

export const MyProjectItem = (props) => {
    return (
        <ListItem
            key={props.project.id}
            disableGutters
            secondaryAction={
                <Button variant="contained" component="a" href={`/project/${props.project.id}`} >Open</Button>
            }
        >
            <ListItemAvatar >
                <Avatar alt="Project">
                    <AccountTreeRoundedIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={<Stack direction="row" spacing={1}>
                <Typography>{props.project.name}</Typography>
                {props.project.ispublic == true && <Chip label="Public" color="primary" size="small" />}
            </Stack>} secondary={props.project.description} sx={{ paddingRight: 5 }}> </ListItemText>
        </ListItem>
    );
};